import * as swcHelpers from '@swc/helpers';
import { useEffect, useMemo } from 'react';
import { createCustomEvent } from './utils.js';

const dispatchTrackErrorEvent = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(getErrorDetails) {
        try {
            const dynamicDetails = yield getErrorDetails();
            const fullDetails = swcHelpers.objectSpread({
                id: 'Event',
                Events_Error: '1'
            }, dynamicDetails);
            const event = createCustomEvent(fullDetails);
            globalThis.dispatchEvent(event);
        } catch (error) {
            console.error('[Tealium] Error dispatching track error event:', error);
        }
    });
    return function dispatchTrackErrorEvent(getErrorDetails) {
        return _ref.apply(this, arguments);
    };
}();
const handleTrackErrorEvent = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(getErrorDetails) {
        try {
            const dynamicDetails = yield getErrorDetails();
            if (dynamicDetails !== undefined) {
                yield dispatchTrackErrorEvent(()=>Promise.resolve(dynamicDetails)
                );
            }
        } catch (error) {
            console.error('[Tealium] Error handling track error event:', error);
        }
    });
    return function handleTrackErrorEvent(getErrorDetails) {
        return _ref.apply(this, arguments);
    };
}();
const useTrackErrorEvent = (getErrorDetails)=>{
    useEffect(()=>{
        handleTrackErrorEvent(getErrorDetails);
    }, [
        getErrorDetails
    ]);
};
const useDispatchTrackErrorEvent = ()=>{
    return useMemo(()=>{
        return function() {
            var _ref = swcHelpers.asyncToGenerator(function*(getErrorDetails) {
                yield handleTrackErrorEvent(getErrorDetails);
            });
            return function(getErrorDetails) {
                return _ref.apply(this, arguments);
            };
        }();
    }, []);
};

export { dispatchTrackErrorEvent, useDispatchTrackErrorEvent, useTrackErrorEvent };
//# sourceMappingURL=use-track-error-event.js.map
